var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"size":"xl","id":"banner-preview","title":"Banner Preview","hide-footer":_vm.hideFooter}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.html)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }